export let statusConstants = {
    header: "Paperless KYC upgrade",
    genericErrorMsg: "Sorry, Your KYC upgrade was not completed due to an error. Please try again after sometime.",
    sessionExpiry: "Your session has been expired and the paperless KYC upgrade did not complete. Please try again.",
    kycAlreadyDone: "Your KYC has been upgraded already.",
    kycAlreadyDoneDesp: "As per our records, your Amazon Pay Later account has been upgraded already. No action needed."
}